module.exports = __webpack_public_path__ + "prod/1.42.2/img/cpys_six.036782a0.png";